import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { CommandProgress } from '@rocksoft/mdm-sdk-v2';

export type CommandProgressState = EntityState<CommandProgress>;

export function selectIdFromCommandProgress(commandProgress: CommandProgress): string {
  return `${commandProgress.udid}-${commandProgress.commandUUID}`;
}

export const adapter: EntityAdapter<CommandProgress> = createEntityAdapter<CommandProgress>({
  selectId: selectIdFromCommandProgress,
  sortComparer: (a, b) => {
    return new Date(b.created).getTime() - new Date(a.created).getTime();
  },
});

export const initialState: CommandProgressState = adapter.getInitialState();
